// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"75":"70f22c6f","319":"b69a8747","821":"9ef5b67f"}[chunkId] + ".chunk.js";
};